export default function SiteNav({ sections }) {
  return (
    <header className="site-nav">
      <a className="site-nav__mark" href="#hero" aria-label="返回首页">
        ZL<span>®</span>
      </a>
      <nav aria-label="主要导航">
        <ol className="site-nav__links">
          {sections.map((section, index) => (
            <li key={section.id}>
              <a href={`#${section.id}`}>
                <span>{String(index + 1).padStart(2, "0")}</span>
                {section.label}
              </a>
            </li>
          ))}
        </ol>
      </nav>
      <span className="site-nav__status">SHA · 31°14′N</span>
    </header>
  );
}
